import { useMutation } from "@tanstack/react-query";
import { useDependencies } from "./useDependencies";
import { useAuth } from "./useAuth";
import { useDocumentationArea } from "./useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";

export const useCreateOpenAdminIDVSession = () => {
  const { token } = useAuth();
  const { documentationArea } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();
  const actorId = documentationArea?.getActor().getId();

  if (!documentationArea) {
    throw new DocumentationAreaNotFoundError();
  }

  if (!actorId) {
    throw new Error("Actor not found");
  }

  const mutationFn = async () => {
    return await documentationAreaController.createOpenAdminIDVSession(
      token,
      documentationArea.getId(),
      actorId,
      documentationArea.getLocale(),
    );
  };

  const { data, mutate, isPending, isSuccess, error } = useMutation({
    mutationFn,
  });

  return {
    isPending,
    createOpenAdminIDVSession: mutate,
    widgetLink: data?.widgetLink,
    isSuccess,
    error,
  };
};
